<ng-container *transloco="let t">
  <div>
    <label>{{t('plan-steps-procedure-report.sessions')}}:</label>
    <ul>
      <li *ngFor="let s of step.sessions">
        <a class="font-weight-bold" routerLink="./session/{{s.id}}">
          {{s.startedBy.lastname ? s.startedBy.lastname : ''}}
          {{s.startedBy.firstname ? s.startedBy.firstname : ''}}
          ({{s.startedBy.username }})
        </a>
      </li>
    </ul>
  </div>
</ng-container>
